import { Controller } from "stimulus";
import { EventToast, EventCheckUserLogin } from "../events";

export default class extends Controller {
  static targets = ["solidStar", "emptyStar"];

  connect() {
    fetch("/portfolio/coins", {
      credentials: "same-origin"
    })
      .then(response => {
        if (response.status != 200) {
          // Set flag for use later
          this.userLoggedIn = false;
          return;
        }

        this.userLoggedIn = true;
        return response.json();
      })
      .then(res => {
        if (!res) {
          return;
        }

        const coinIdMap = {};
        res.coin_ids.forEach(cid => {
          coinIdMap[cid] = true;
        });

        this.solidStarTargets.forEach(star => {
          if (coinIdMap[star.dataset.coinId]) {
            star.style.display = "";
            this.showOtherStar(star, false);
          }
        });
      });

    window.addEventListener(EventCheckUserLogin, e => {
      this.userLoggedIn = e.detail.userLoggedIn;
    });
  }

  showOtherStar(currentStar, show = true) {
    if (currentStar.previousElementSibling) {
      currentStar.previousElementSibling.style.display = show ? "" : "none";
    } else if (currentStar.nextElementSibling) {
      currentStar.nextElementSibling.style.display = show ? "" : "none";
    }
  }

  toggleFavorite(e) {
    const star = e.currentTarget;
    star.style.display = "none";
    this.showOtherStar(star, true);

    const coinSymbol = star.dataset.coinSymbol.toUpperCase();

    if (this.userLoggedIn) {
      if (star.dataset.type === "unfavorite") {
        window.dispatchEvent(
          new CustomEvent(EventToast, {
            detail: {
              notice: `Removed ${coinSymbol} from Dashboard`
            }
          })
        );
      } else {
        window.dispatchEvent(
          new CustomEvent(EventToast, {
            detail: {
              notice: `Added ${coinSymbol} to Dashboard`
            }
          })
        );
      }
    }
  }

  checkUserLogin(e) {
    if (this.userLoggedIn === false) {
      e.preventDefault();
      e.target.parentNode.href = "#";
      e.target.parentNode.dataset.toggle = "modal";
      e.target.parentNode.dataset.target = "#signInModal";
    }
  }
}
